// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602251534/js/" + chunkId + "." + {"44":"30d45e43","225":"7229915e","481":"aeef7c98","486":"ece1cec3","770":"472dd805"}[chunkId] + ".0.03296958604808964.chunk.js";
};